import React, { useState } from "react";
import { Paper, Grid, Typography, Box, Tabs, Tab } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailIcon from "@mui/icons-material/Email";
import PersonIcon from "@mui/icons-material/Person";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import DoctorAvailability from "./DoctorAvailability"; // Import schedule component
import DoctorServices from "./DoctorServices"; // Import services component
import ProviderAvailableSchedule from "../ProviderSchedule/ProviderAvailableSchedule";
import ProviderScheduleCreate from "../ProviderSchedule/ProviderScheduleCreate";

const DoctorDetails = ({ doctor }) => {
  const [selectedTab, setSelectedTab] = useState(0);

  const capitalize = (text) => (text ? text.charAt(0).toUpperCase() + text.slice(1) : "");

  return (
    <>
      {/* Doctor Header Section */}
      <Paper
        elevation={3}
        sx={{
          padding: "20px",
          background: "linear-gradient(135deg, #012A4A 0%, #025E73 35%, #028391 65%, #03A9A3 100%)",
          color: "white",
          borderRadius: "8px",
        }}
      >
        <Grid container spacing={3} alignItems="center">
          {/* Avatar/Icon */}
          <Grid item xs={12} sm={1} display="flex" justifyContent="center">
            <Box
              sx={{
                width: 80,
                height: 80,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "white",
                borderRadius: "50%",
              }}
            >
              <PersonIcon sx={{ fontSize: 60, color: "#025E73" }} />
            </Box>
          </Grid>

          {/* Doctor Name */}
          <Grid item xs={12} sm={3} sx={{ textAlign: "center" }}>
            <Typography variant="h5" sx={{ fontWeight: "bold" }}>
              {capitalize(doctor.fname)} {capitalize(doctor.lname)}
            </Typography>
          </Grid>

          {/* Doctor Contact Info */}
          <Grid item xs={12} sm={3} sx={{ textAlign: "left" }}>
            <Typography variant="body2">
              <EmailIcon sx={{ verticalAlign: "middle" }} /> <strong>Email:</strong> {doctor.email}
            </Typography>
            <Typography variant="body2">
              <LocalPhoneIcon sx={{ verticalAlign: "middle" }} /> <strong>Contact:</strong> {doctor.phonecell}
            </Typography>
            <Typography variant="body2">
              <BusinessIcon sx={{ verticalAlign: "middle" }} /> <strong>Facility:</strong> {doctor.facility}
            </Typography>
          </Grid>

          {/* Address & Role */}
          <Grid item xs={12} sm={4} sx={{ textAlign: "left" }}>
            <Typography variant="body2">
              <PersonIcon sx={{ verticalAlign: "middle" }} /> <strong>Role:</strong> {capitalize(doctor.user_type)}
            </Typography>
            <Typography variant="body2">
              <LocationOnIcon sx={{ verticalAlign: "middle" }} /> <strong>Address:</strong> {doctor.street}, {doctor.city} - {doctor.zip}
            </Typography>
          </Grid>
        </Grid>
      </Paper>

      {/* Tabs for Schedule & Services */}
      <Box sx={{ width: "100%", mt: 2 }}>
        <Tabs value={selectedTab} onChange={(e, newValue) => setSelectedTab(newValue)} variant="fullWidth">
          <Tab label="Schedule" />
          <Tab label="Create Schedule" />
          <Tab label="Services" />
        </Tabs>

        {/* Tab Content */}
        <Box sx={{ p: 2 }}>
          {selectedTab === 0 && <ProviderAvailableSchedule doctor={doctor} />}
          {selectedTab === 1 && <ProviderScheduleCreate doctor={doctor} />}
          {selectedTab === 2 && <DoctorServices doctor={doctor} />}
        </Box>
      </Box>
    </>
  );
};

export default DoctorDetails;
